export default function() {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    // { label: "ID", prop: "id" },
    { label: "角色", prop: "title", slots: "title", width: 200 },
    // {
    //   label: "分配门店",
    //   prop: "store_id",
    //   slots: "store_id",
    //   width: 200
    // },
    { label: "账号", prop: "username",
      width: 200 },
    // { label: "密码(已加密)", prop: "password" },
    { label: "手机号", prop: "phone_number",
      width: 200 },
    // { label: "绑定微信openid", prop: "openid", slots: "openid", width: 150 },
    // {
    //   label: "微信绑定",
    //   prop: "saoma",
    //   slots: "saoma",
    //   width: 100,
    // },
    { label: "昵称", prop: "alias_name" },
    { label: "账号折扣", prop: "discount", slots: "discount" },
    {
      label: "登录异常(超过5次冻结)",
      prop: "error",
      slots: "error",
      width: 200
    },
    {
      label: "创建时间",
      prop: "create_time",
      width: 180,
    },
    {
      label: "操作",
      prop: "operation",
      width: 120,
      slots: "operation",
      fixed: "right",
    },
  ];
}
